var MODAL_TYPE = {
  DEFAULT: 'default',
  ALERT: 'alert',
  CONFIRM: 'confirm',
  NOTIFICATION: 'notification',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  HELP: 'help',
  INFO: 'info'
};
var modalTypes = [MODAL_TYPE.DEFAULT, MODAL_TYPE.ALERT, MODAL_TYPE.CONFIRM, MODAL_TYPE.NOTIFICATION, MODAL_TYPE.WARNING, MODAL_TYPE.ERROR, MODAL_TYPE.SUCCESS, MODAL_TYPE.HELP, MODAL_TYPE.INFO];
var MODAL_TYPE_V2 = {
  INFORMATION: 'information',
  DECISION: 'decision',
  SELECTION: 'selection',
  FORM: 'form'
};
var MODAL_SUB_TYPE_V2 = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFORMATION: 'information'
};

export default MODAL_TYPE;
export { MODAL_SUB_TYPE_V2, MODAL_TYPE, MODAL_TYPE_V2, modalTypes };
//# sourceMappingURL=constants.js.map
